import * as React from "react";

import { getClasses } from "utils";

import { CurrentStepType, StepType } from "./types";

export default function ProgressBar(props: {
  currentStep: CurrentStepType;
  steps: StepType[];
}): JSX.Element {
  const {
    currentStep: { index: currentIndex, label: currentLabel },
    steps,
  } = props;

  const Steps = [];
  const labels = {};

  for (let i = 0, l = steps.length; i < l; i++) {
    const { label } = steps[i];

    // Enforce unique step by label
    if (labels[label]) continue;

    labels[label] = true;

    const isCurrent = label === currentLabel;
    const completed = i < currentIndex && !isCurrent;

    Steps.push(
      <li
        className={getClasses({ active: isCurrent, completed })}
        data-current={isCurrent}
        key={label}
      >
        <div className="content">
          <div className="step-title">{label}</div>
        </div>
      </li>,
    );
  }
  
  return <ol className="progress-bar">{Steps}</ol>;
}
